import { render, staticRenderFns } from "./RepairItem.vue?vue&type=template&id=264aa62c"
import script from "./RepairItem.vue?vue&type=script&lang=js"
export * from "./RepairItem.vue?vue&type=script&lang=js"
import style0 from "./RepairItem.vue?vue&type=style&index=0&id=264aa62c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports